import type { ReactNode } from 'react';
import { IconWarningTriangle } from '@/icons';
import { cn } from '@/helpers/classnames';

interface ErrorBannerProps {
  id?: string;
  children: ReactNode;
  className?: string;
  /** Omit for default warning icon. Pass `null` to hide the icon. */
  icon?: ReactNode;
}

export const ErrorBanner = ({
  id,
  children,
  className,
  icon,
}: ErrorBannerProps) => {
  return (
    <div
      id={id}
      role="alert"
      className={cn(
        'flex flex-row items-center rounded-md bg-red-100 p-4 text-red-800 [&_svg]:text-red-800',
        className,
      )}
    >
      {icon !== null && (
        <span className="mr-4 flex size-7 min-w-7 shrink-0 items-center justify-center [&_svg]:size-7 [&_svg]:min-w-7">
          {icon ?? (
            <IconWarningTriangle
              className="size-7 min-w-7"
              aria-hidden="true"
            />
          )}
        </span>
      )}
      <span>{children}</span>
    </div>
  );
};
